class BackToTop extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.scrollDistance = parseInt(this.dataset.scrollDistance, 10) || 600
    this.isTicking = false

    this.update()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.onClick = this.onClick.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
    this.listeners.add(this.els.button.element, 'click', this.onClick)
  }

  onScroll () {
    if (this.isTicking) return

    this.isTicking = true
    window.requestAnimationFrame(() => {
      this.update()
      this.isTicking = false
    })
  }

  onClick () {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    })
  }

  update () {
    this.setAttribute('aria-hidden', window.scrollY <= this.scrollDistance)
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop)
}
